
<div class="associated-object-model">
  <div class="container">
    <template v-if="index > 0">
      <br>
      <row>
        <column class="sz100">
          <and-or-select v-model="ruleSetsRoot.join_type" outside-modal></and-or-select>
        </column>
      </row>
    </template>

    <div class="form-element align-center rule-set">
      <row>
        <column>
          <a-select
            :id="`select_object_model_association_${index}`"
            :options="objectModelSearchOptions"
            @input="selectObjectModel"
            :value="objectModelAssociation.object_model_client_id"
            bind-by-object
            placeholder="Select object model..."
          ></a-select>
        </column>
        <column v-if="isUserType">
          <a-select
            :id="`select_account_relationships_${index}`"
            class="rule"
            :options="accountRelationVOptionSet"
            v-model="objectModelAssociation.account_relation_client_id"
            placeholder="Select one..."
          ></a-select>
        </column>
        <column v-if="isEntityType">
          <a-select
            :id="`select_entity_account_relationships_${index}`"
            class="rule"
            :options="entityAccountRelationVOptionSet"
            v-model="objectModelAssociation.entity_account_relation_client_id"
            placeholder="Select one..."
          ></a-select>
        </column>
        <column v-if="includeRelativeTimeCondition">
          <a-select
            v-if="objectModelAssociation.object_model_client_id"
            :id="`select_object_model_prerequisite_type_${index}`"
            :options="objectModelPrereqOptions"
            v-model="objectModelAssociation.prerequisite_type"
          ></a-select>
        </column>

            <div class="dropdown pt-2 pl-2">
              <button
                class="dropdown-toggle btn-icon clear-area controllers"
                @click="openContextMenu"
              >
                <icon class="kebab"></icon>
                <span class="sr-only">More Actions Dropdown</span>
              </button>
            </div>

      </row>

      <template v-if="objectModelAssociation.object_model_client_id && (includeRelativeTimeCondition && objectModelAssociation.prerequisite_type === objectModelPrerequisiteType.ConditionalRule || !includeRelativeTimeCondition)">
        <div :id="`object_model_association_conditional_rule_sets_${index}`">
          <edit-conditional-rule-set
            v-if="ruleSets.length > 0"
            :parent="objectModelAssociation"
            :ruleSet="ruleSets[0]"
            outside-modal
          ></edit-conditional-rule-set>
        </div>
      </template>

      <template v-if="includeRelativeTimeCondition && objectModelAssociation.object_model_client_id && objectModelAssociation.prerequisite_type === objectModelPrerequisiteType.RelativeDate">
        <configure-relative-time-component
          id="relative_time_period"
          additional-class="layout"
          v-model="objectModelAssociation.relative_time_period"
          prop_key="relative_time_period"
          :model="objectModelAssociation"
          :unitOptions="DurationAndTimeHelper.durationUnitLongOptions"
          :options="[{label: 'Relative time interval', value: DurationType.propertyBasedTimeSpan,
                  sectionConfig:
                    {sectionLabel: '',
                    includeWindowComparisonOptions: true,
                    dropdownOptions: relativeTimeIntervalPropertyBasedOptions }
                  }]">
        </configure-relative-time-component>
      </template>

      <row v-if="enableCustomErrorMessages && objectModelSelected" class="text-left">
        <column>
          <label :for="`${objectModelAssociation.object_model_client_id}-error-message-${index}`">Custom Error Message</label>
          <wysiwyg  :id="`${objectModelAssociation.object_model_client_id}-error-message-${index}`"
                    :name="`${objectModelAssociation.object_model_client_id}-error-message-${index}`"
                    v-model="objectModelAssociation.error_message"
                    :config-options="wysiwygConfig"
          ></wysiwyg>
        </column>
      </row>

    </div>
  </div>
</div>
